import { useMemo } from 'react';
import useFieldValidation from 'hooks/useFieldValidation';
function getFieldLabel(name, t) {
    switch (name) {
        case 'name':
            return t('chat:CHANNEL_NAME');
        case 'members':
            return t('chat:SELECT_MEMBERS');
        default:
            return name;
    }
}
function getFieldError(name, form, selectedUsers, t) {
    var _a;
    if (name === 'name')
        return !((_a = form.name) === null || _a === void 0 ? void 0 : _a.trim()) ? t('specification:required_field') : null;
    if (name === 'members')
        return selectedUsers.length === 0 ? t('chat:SELECT_AT_LEAST_ONE_MEMBER') : null;
    return null;
}
function useChannelValidation(form, selectedUsers, t) {
    const validatedFields = useMemo(() => ['name', 'members'], []);
    return useFieldValidation(validatedFields, (field) => getFieldError(field, form, selectedUsers, t), (field) => getFieldLabel(field, t));
}
export default useChannelValidation;
